import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from '../api/axiosInstance';

// Fetch voucher number settings
export const fetchVoucherNumberSettings = createAsyncThunk(
  'voucherNumberSettings/fetch',
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get('/api/settings/voucher-number-settings/');
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// Get current numbers
export const getCurrentNumbers = createAsyncThunk(
  'voucherNumberSettings/getCurrentNumbers',
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get('/api/settings/voucher-number-settings/current-numbers/');
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// Create or update voucher number settings
export const saveVoucherNumberSettings = createAsyncThunk(
  'voucherNumberSettings/save',
  async ({ voucherType, startingNumber }, { rejectWithValue }) => {
    try {
      // Try to get existing settings first
      const listResponse = await axiosInstance.get('/api/settings/voucher-number-settings/');
      const existing = listResponse.data.find(s => s.voucher_type === voucherType);
      
      if (existing) {
        // Update existing
        const response = await axiosInstance.patch(
          `/api/settings/voucher-number-settings/${existing.id}/`,
          { starting_number: startingNumber }
        );
        return response.data;
      } else {
        // Create new
        const response = await axiosInstance.post('/api/settings/voucher-number-settings/', {
          voucher_type: voucherType,
          starting_number: startingNumber
        });
        return response.data;
      }
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const voucherNumberSettingsSlice = createSlice({
  name: 'voucherNumberSettings',
  initialState: {
    settings: [],
    currentNumbers: null,
    loading: false,
    error: null,
    saving: false
  },
  reducers: {
    clearError: (state) => {
      state.error = null;
    }
  },
  extraReducers: (builder) => {
    builder
      // Fetch settings
      .addCase(fetchVoucherNumberSettings.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchVoucherNumberSettings.fulfilled, (state, action) => {
        state.loading = false;
        state.settings = action.payload;
      })
      .addCase(fetchVoucherNumberSettings.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Get current numbers
      .addCase(getCurrentNumbers.pending, (state) => {
        state.loading = true;
      })
      .addCase(getCurrentNumbers.fulfilled, (state, action) => {
        state.loading = false;
        state.currentNumbers = action.payload;
      })
      .addCase(getCurrentNumbers.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Save settings
      .addCase(saveVoucherNumberSettings.pending, (state) => {
        state.saving = true;
        state.error = null;
      })
      .addCase(saveVoucherNumberSettings.fulfilled, (state, action) => {
        state.saving = false;
        const index = state.settings.findIndex(s => s.id === action.payload.id);
        if (index >= 0) {
          state.settings[index] = action.payload;
        } else {
          state.settings.push(action.payload);
        }
      })
      .addCase(saveVoucherNumberSettings.rejected, (state, action) => {
        state.saving = false;
        state.error = action.payload;
      });
  }
});

export const { clearError } = voucherNumberSettingsSlice.actions;
export default voucherNumberSettingsSlice.reducer;
